import { gql } from 'graphql-tag'

const featuresListFragment = gql`
  fragment featuresListFragment on FeatureToggles {
    sentirEmotionJournalNotes
    sentirEmotionJournalSecondaryEmotions
    layoutThema
    entityUsersOnlineStatus
    paranaNotice
    reportsV2
    enableReadingFluencyReapplication
    reportReadingGoalsEnabled
    usageTime
    intermediaryPageRecommendations
    useImportationAiBased
    comprehensionQuestions
    useNewImportationProcess
    hideNews
    pagarmeV5Enabled
    showPressreaderIconOnHeader
    newPermissionsManagement
    readingFluencySimplifiedResults
    askTheBook
    readingReportV2
    autoCorrectionWithAi
    fluencyEmptyState
    newReadingAssessmentV2
    doActivityV2
    bookReadingRecord
    ottoAiEnabled
    hiddenLeagueName
    suspiciousActivityUsersSeduc
    adminPanelV2Rollout
    sharedReadingEnabled
    storyTree
    maple
    runningRecords
    rewind
    onboardingAlunoV3
    onboardingTeacher
    activitiesV3
    readAloudV2Leveling
    summaryReportV2
  }
`

const onboardingV2TutorialFragment = gql`
  fragment onboardingV2TutorialFragment on Tutorial {
    id
    interactions
    name
    state
    updatedAt
    userId
  }
`

const gamificationOnboardingTutorialFragment = gql`
  fragment gamificationOnboardingTutorialFragment on Tutorial {
    id
    interactions
    name
    state
    updatedAt
    userId
  }
`
const adminPanelV2OnboardingTutorialFragment = gql`
  fragment adminPanelV2OnboardingTutorialFragment on Tutorial {
    id
    interactions
    name
    state
    updatedAt
    userId
  }
`

export const userBasicInfosQuery = gql`
  ${featuresListFragment}
  ${onboardingV2TutorialFragment}
  ${gamificationOnboardingTutorialFragment}
  ${adminPanelV2OnboardingTutorialFragment}
  query UserBasicInfos {
    me {
      id
      requiresPayment
      hasPendingPaymentTransactions
      email
      apiToken
      accessToken
      firstAccess
      name
      permissions
      username
      products
      filledOnboardingJobInfo
      isAdmin
      suspicionScore
      teacher {
        id
        blockedBooks
        permissions
        role
        teacherEntities
        isFamilyPaying
        showFlag
        updateStatus {
          skips
          updated
          emailConfirmed
        }
        root {
          id
          name
          requirePayment
          segment
        }
        englishTrial {
          endDate
          startDate
          remainingDays
        }
      }
      reader {
        id
        permissions
        accessDaysLeft
        contentFilters
        canAccessOnboarding
        acervos
        paymentStatus
        root {
          id
          name
          paymentInfo
          daysLeft
          paymentPrice
          requirePayment
          type
          rootAcervo
          maxSimultaneousUsers
          currentSimultaneousUsers
          nextReaderSpotAvailable
          segment
          expirationDate
        }
        entity {
          id
          ancestry
          requirePayment
          degree
          name
          type
          expirationDate
          paymentInfo
          contractInfo {
            type
            usesContractModule
            features
          }
        }
        testPeriods {
          id
          createdAt
          durationInDays
          readerId
          type
        }
      }
      featureToggles {
        ...featuresListFragment
      }
      onboardingV2Tutorial {
        ...onboardingV2TutorialFragment
      }
      gamificationOnboardingTutorial {
        ...gamificationOnboardingTutorialFragment
      }
      adminPanelV2OnboardingTutorial {
        ...adminPanelV2OnboardingTutorialFragment
      }
      jobPositions
      jobAreas
    }
  }
`

export const getChangedPasswordStatus = gql`
  query GetChangedPasswordStatus {
    me {
      id
      changedPassword
    }
  }
`

export const getGamificationOnboardingStatus = gql`
  ${gamificationOnboardingTutorialFragment}
  query GamificationOnboardingTutorial {
    me {
      id
      gamificationOnboardingTutorial {
        ...gamificationOnboardingTutorialFragment
      }
    }
  }
`

export const getNotificationPreferences = gql`
  query NotificationsPreferences {
    notificationsPreferences {
      weeklyReadingReport
    }
  }
`

export const getUserFeatureToggles = gql`
  ${featuresListFragment}
  query getUserFeatureToggles {
    me {
      id
      featureToggles {
        ...featuresListFragment
      }
    }
  }
`

export const getReaderReadingGoalStatus = gql`
  query GetReaderReadingGoalStatus {
    me {
      id
      reader {
        id
        readingGoalStatus {
          goal
          readingTime
        }
      }
    }
  }
`

export const getUserQuery = gql`
  query GetUser($userId: Int!) {
    getUser(userId: $userId) {
      id
      name
      email
      accessToken
      reader {
        id
        rootId
        entity {
          id
          name
        }
      }
      isAdmin
    }
  }
`

export const getUserJobPositionsAndRoles = gql`
  query GetUserJobPositionsAndRoles {
    me {
      id
      jobPositions
      jobAreas
      roles
    }
  }
`

export const getReaderForest = gql`
  query GetReaderForest {
    me {
      id
      reader {
        id
        forest {
          id
        }
      }
    }
  }
`
